// Config panel for the "trigger_alarm" action block
import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  FormHelperText
} from '@mui/material';

const TriggerAlarmConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    const type = updated.alarmType || 'intrusion';
    onSummaryChange(`Trigger ${type} alarm`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Creates an alarm record for this location. The alarm will appear in the
        monitoring dashboard and can trigger notifications.
      </Typography>

      <FormControl fullWidth size="small" required>
        <InputLabel>Alarm Type</InputLabel>
        <Select
          value={config.alarmType || 'intrusion'}
          onChange={(e) => handleChange('alarmType', e.target.value)}
          label="Alarm Type"
        >
          <MenuItem value="intrusion">Intrusion</MenuItem>
          <MenuItem value="fire">Fire</MenuItem>
          <MenuItem value="technical">Technical</MenuItem>
          <MenuItem value="medical">Medical</MenuItem>
          <MenuItem value="custom">Custom</MenuItem>
        </Select>
        <FormHelperText>The type of alarm to create</FormHelperText>
      </FormControl>

      <TextField
        size="small"
        label="Description"
        value={config.description || ''}
        onChange={(e) => handleChange('description', e.target.value)}
        multiline
        rows={2}
        required
        helperText="Description of why this alarm was triggered"
      />

      <TextField
        size="small"
        label="Source"
        value={config.source || 'automation'}
        onChange={(e) => handleChange('source', e.target.value)}
        helperText="Source identifier (default: automation)"
      />
    </Box>
  );
};

export default TriggerAlarmConfig;
